import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { FooterLinks } from "./FooterLinks";
import { FooterContact } from "./FooterContact";

const Footer = () => (
  <footer className="bg-[#1B2A4A] text-white">
    {/* Main Footer */}
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-full bg-white p-1 shrink-0">
              <img
                src="/logo.png"
                alt="Willow Ridge Golf & Country Club"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <div className="font-serif text-xl font-bold leading-tight">
                Willow Ridge
              </div>
              <div className="text-[#C9A96E] text-xs tracking-[0.2em] uppercase">
                Golf & Country Club
              </div>
            </div>
          </div>
          <p className="text-white/60 text-sm leading-relaxed mb-6">
            Premier golf experience in the heart of Chatham-Kent. Exceptional
            course conditions, elegant event spaces, and memorable dining since
            establishment.
          </p>
          {/* Social icons */}
          <div className="flex gap-3">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#C9A96E]/20 flex items-center justify-center transition-colors duration-300"
            >
              <Facebook size={18} />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#C9A96E]/20 flex items-center justify-center transition-colors duration-300"
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <FooterLinks />
        <FooterContact />
      </div>
    </div>

    {/* Bottom Bar */}
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-white/40 text-sm">
          © {new Date().getFullYear()} Willow Ridge Golf & Country Club. All
          rights reserved.
        </p>
        <div className="flex gap-6">
          <Link
            to="/contact"
            className="text-white/40 hover:text-white/70 text-sm transition-colors"
          >
            Privacy Policy
          </Link>
          <Link
            to="/contact"
            className="text-white/40 hover:text-white/70 text-sm transition-colors"
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
